import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar";
import Card from "react-bootstrap/Card";
import DataTable from 'react-data-table-component';
import axios from 'axios';
import * as FaIcons from "react-icons/fa";
import Cargando from "../../components/cargando";
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import SinPermisos from "./../../components/sinpermisos";
import Nav from 'react-bootstrap/Nav'; // Importar Nav

const url = "https://api.mrcirp.com/public/usuariospanel";
const urlpost = "https://api.mrcirp.com/public/loginusuarios";
const urlput = "https://api.mrcirp.com/public/userpaneldelete";

const Colores = () => {

  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);
  const [permisos, setPermisos] = useState([]);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem('loginUser')
    if(loginUserJSON){
      const user= JSON.parse(loginUserJSON)
      setUsers(user);
    }
   }, []);

  //////////////Iniciando Status data//////////////////////////
  const [data, setData] = useState([]);

  const [datosSeleccionados, setDatosSeleccionados] = useState({
    nombreuser: '',
    username: '',
    password: '',
    confirmPassword: '',
    rol: 'cliente', // Valor predeterminado
    status: 'activo' // Valor predeterminado
  });

  /////////////////Datatable/////////////////////////////////

  const paginationComponentOptions = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todos',
  };

  const [pending, setPending] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setData(data);
      setPending(false);
    }, 100);
    return () => clearTimeout(timeout);
  });

  const columns = [
    {
      name: "Accion",
      button: true,
      cell: (row) => (
        <Nav style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button
            onClick={() => {
              setDatosSeleccionados(row);
              setModalEditar(true);
            }}
            className="custom-btn"
            style={{ marginRight: "25px" }}
          >
            <FaIcons.FaRegEdit />
          </button>
          <button
            onClick={() => {
              setDatosSeleccionados(row);
              abrirModalDesactivar();
            }}
            className="custom-btn"
            style={{ marginRight: "5px" }}
          >
            <FaIcons.FaAdjust />
          </button>
        </Nav>
      ),
    },

    {
      name: 'Id',
      selector: (row) => row.id,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: 'Nombre',
      selector: (row) => row.nombreuser,
    },
    {
      name: 'Usuario',
      selector: (row) => row.username,
    },
    {
      name: 'Contraseña',
      selector: (row) => row.password,
    },
    {
      name: 'Rol',
      selector: (row) => row.rol,
    },
    {
      name: 'Status',
      selector: (row) => row.status,
    },
  ];

  /////////////Buscar datos//////////////////////////////////
  const [buscar, setBuscar] = useState("");
  const [filtrobuscar, setFiltroBuscar] = useState([]);

  useEffect(() => {
    const result = data.filter((resultdata) => {
      return resultdata.username.toLowerCase().match(buscar.toLowerCase());
    });
    setFiltroBuscar(result);
  }, [buscar, data]);

  /////////////Mostrar datos//////////////////////////////////
  const peticionGet = async () => {
    await axios.get(url).then(response => {
      console.log(response.data);
      setData(response.data);
      setFiltroBuscar(response.data);
      console.log(response.data);
    })
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    await peticionGet();
  }, []);

  ///////////////Insertar Datos//////////////////////////////////
  const [modalCrear, setModalCrear] = useState(false);
  const abrirModalCrear = () => {
    setDatosSeleccionados({
      nombreuser: '',
      username: '',
      password: '',
      confirmPassword: '',
      rol: 'cliente', // Valor predeterminado
      status: 'activo' // Valor predeterminado
    });
    setModalCrear(true);
  }

  const peticionPost = async () => {
    if (datosSeleccionados.password !== datosSeleccionados.confirmPassword) {
      alert('Las contraseñas no coinciden');
      return;
    }
    const datosCompletos = {
      nombreuser: datosSeleccionados.nombreuser,
      username: datosSeleccionados.username,
      password: datosSeleccionados.password,
      rol: datosSeleccionados.rol,
      status: datosSeleccionados.status
    };
    console.log(datosCompletos);
    await axios.post(urlpost, datosCompletos).then(res => {
      console.log(res.data);
      peticionGet();
      setError(false);
      setModalCrear(false);
    })
      .catch((err) => {
        setError(true);
      })
  }

  //////////////Editar datos/////////////////////////////////////
  const [modalEditar, setModalEditar] = useState(false);
  const abrirModalEditar = () => {
    console.log(datosSeleccionados);
    setModalEditar(true);
  }

  const peticionPut = async () => {
    console.log(datosSeleccionados);
    await axios.put(url+'/'+datosSeleccionados.id, datosSeleccionados).then(response => {
      peticionGet();
      setError(false);
      setModalEditar(false);
    })
      .catch((err) => {
        console.log(err);
        setError(true);
        setModalEditar(false);
      })
  }

  const handleChange = e => {
    const { name, value } = e.target;
    setDatosSeleccionados(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const [Error, setError] = useState(false);

  const [modalEditarRol, setModalEditarRol] = useState(false);
  const abrirModalEditarRol = () => {
    setModalEditarRol(true);
  }

  const peticionPutRol = async () => {
    const datosRol = {
      rol: datosSeleccionados.rol
    };
    console.log(datosRol);
    await axios.put(url+'/'+datosSeleccionados.id, datosRol).then(response => {
      peticionGet();
      setError(false);
      setModalEditarRol(false);
    })
      .catch((err) => {
        console.log(err);
        setError(true);
        setModalEditarRol(false);
      })
  }

  const [modalDesactivar, setModalDesactivar] = useState(false);
  const abrirModalDesactivar = () => {
    setModalDesactivar(true);
  }

  const peticionPutStatus = async () => {
    const datosStatus = {
      status: datosSeleccionados.status
    };
    console.log(datosStatus);
    await axios.put(urlput+'/'+datosSeleccionados.id, datosStatus).then(response => {
      peticionGet();
      setError(false);
      setModalDesactivar(false);
    })
      .catch((err) => {
        console.log(err);
        setError(true);
        setModalDesactivar(false);
      })
  }

  console.log(users.rol);
  /////////////////////////////////////////////////////////////////
  if(users.rol!==undefined){
    if(users.rol==='admin'){
  return (
    <div>
      <div className="Colores">
        <Sidebar>
          <Card>
          <Card.Header className="bg-dark text-white" as="h3">
                  <div className="row">
                    <div className="col-md-6">Usuarios registrados</div>
                    <div className="col-md-6 text-right">
                      <button
                        className="btn btn-info"
                        onClick={abrirModalCrear}
                      >
                        <FaIcons.FaPlus /> Añadir usuario
                      </button>
                    </div>
                  </div>
                </Card.Header>
            <Card.Body>
              <Card.Title>Usuarios</Card.Title>
              {
                Error &&
                <div className="alert alert-danger">
                  {<strong>Error: El nombre ya existe! intente con otro nombre.</strong>}
                </div>
              }
              <p>Actividades realizadas por mis usuarios</p>
              <DataTable
                columns={columns}
                data={filtrobuscar}
                progressPending={pending}
                progressComponent={<Cargando />}
                pagination
                paginationComponentOptions={paginationComponentOptions}
                subHeader
                subHeaderComponent={
                  <input
                    type="text"
                    placeholder="Buscar"
                    className="w-25 form-control"
                    value={buscar}
                    onChange={(e) => setBuscar(e.target.value)}
                  />
                }
              />

              {/* Modal para crear usuario */}
              <Modal isOpen={modalCrear}>
                <ModalHeader>
                  <div>
                    <h4>Crear Usuario</h4>
                  </div>
                </ModalHeader>
                <ModalBody>
                  <div className="form-group">
                    <label>Nombre y Apellido</label>
                    <input
                      className="form-control"
                      type="text"
                      name="nombreuser"
                      value={datosSeleccionados.nombreuser}
                      onChange={handleChange}
                    />
                    <br /><br />
                    <label>Usuario</label>
                    <input
                      className="form-control"
                      type="text"
                      name="username"
                      value={datosSeleccionados.username}
                      onChange={handleChange}
                    />
                    <br /><br />
                    <label>Clave</label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={datosSeleccionados.password}
                        onChange={handleChange}
                      />
                      <div className="input-group-append">
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={toggleShowPassword}
                        >
                          {showPassword ? <FaIcons.FaEyeSlash /> : <FaIcons.FaEye />}
                        </button>
                      </div>
                    </div>
                    <br /><br />
                    <label>Confirmar Clave</label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        type={showPassword ? "text" : "password"}
                        name="confirmPassword"
                        value={datosSeleccionados.confirmPassword}
                        onChange={handleChange}
                      />
                      <div className="input-group-append">
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={toggleShowPassword}
                        >
                          {showPassword ? <FaIcons.FaEyeSlash /> : <FaIcons.FaEye />}
                        </button>
                      </div>
                    </div>
                    <br />
                    <label>Rol</label>
                    <select
                      className="form-control"
                      name="rol"
                      value={datosSeleccionados.rol}
                      onChange={handleChange}
                    >
                      <option value="admin">Administrador</option>
                      <option value="cliente">Cliente</option>
                      <option value="soporte">Soporte</option>
                    </select>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <button
                    className="btn btn-dark"
                    onClick={() => setModalCrear(false)}
                  >
                    Cancelar
                  </button>
                  <button className="btn btn-success" onClick={peticionPost}>
                    Crear
                  </button>
                </ModalFooter>
              </Modal>

              {/* Modal para editar usuario */}
              <Modal isOpen={modalEditar}>
                <ModalHeader>
                  <div>
                    <h4>Editar Usuario</h4>
                  </div>
                </ModalHeader>
                <ModalBody>
                  <div className="form-group">
                    <input
                      className="form-control" readOnly
                      type="hidden"
                      name="id"
                      value={datosSeleccionados.id}
                      onChange={handleChange}
                    />
                    <label>Nombre de Usuario</label>
                    <input
                      className="form-control"
                      type="text"
                      name="nombreuser"
                      value={datosSeleccionados.nombreuser}
                      onChange={handleChange}
                    />
                    <br />

                    <label>Rol</label>
                    <select
                      className="form-control"
                      name="rol"
                      value={datosSeleccionados.rol}
                      onChange={handleChange}
                    >
                      <option value="admin">Administrador</option>
                      <option value="cliente">Cliente</option>
                      <option value="soporte">Soporte</option>
                    </select>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <button
                    className="btn btn-dark"
                    onClick={() => setModalEditar(false)}
                  >
                    Cancelar
                  </button>
                  <button className="btn btn-success" onClick={peticionPut}>
                    Actualizar
                  </button>
                </ModalFooter>
              </Modal>

              {/* Modal para editar rol */}
              <Modal isOpen={modalEditarRol}>
                <ModalHeader>
                  <div>
                    <h4>Editar Rol</h4>
                  </div>
                </ModalHeader>
                <ModalBody>
                  <div className="form-group">
                    <label>Rol</label>
                    <select
                      className="form-control"
                      name="rol"
                      value={datosSeleccionados.rol}
                      onChange={handleChange}
                    >
                      <option value="admin">Administrador</option>
                      <option value="cliente">Cliente</option>
                      <option value="soporte">Soporte</option>
                    </select>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <button
                    className="btn btn-dark"
                    onClick={() => setModalEditarRol(false)}
                  >
                    Cancelar
                  </button>
                  <button className="btn btn-success" onClick={peticionPutRol}>
                    Actualizar Rol
                  </button>
                </ModalFooter>
              </Modal>

              {/* Modal para desactivar usuario */}
              <Modal isOpen={modalDesactivar}>
                <ModalHeader>
                  <div>
                    <h4>Cambiar Status Usuario</h4>
                  </div>
                </ModalHeader>
                <ModalBody>
                  <div className="form-group">
                    <p>¿Estás seguro de que deseas cambiar el estado del usuario?</p>
                    <select
                      className="form-control"
                      name="status"
                      value={datosSeleccionados.status}
                      onChange={handleChange}
                    >
                      <option value="activo">Activo</option>
                      <option value="inactivo">Inactivo</option>
                    </select>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <button
                    className="btn btn-dark"
                    onClick={() => setModalDesactivar(false)}
                  >
                    Cancelar
                  </button>
                  <button className="btn btn-danger" onClick={peticionPutStatus}>
                    Actualizar
                  </button>
                </ModalFooter>
              </Modal>
            </Card.Body>
          </Card>
        </Sidebar>
      </div>
    </div>
  );}
  else{
    return (
      <div>
      <Sidebar>
         <SinPermisos/>
       </Sidebar>  
      </div>
    );
  }}
  else{
    return (
      <div>
      <Sidebar>
         <SinPermisos/>
       </Sidebar>  
      </div>
    );
  }
};

export default Colores;